<template>
<div class="project">
  <div class="item" v-for="(item, index) in project" :key="index">
    <div class="item_title">{{ item.name }}</div>
    <img class="item_image" v-if="index==0" src="@/assets/project/AutoParking.jpg" height="300">
    <img class="item_image" v-if="index==1" src="@/assets/project/SmartBlind.png" height="300" width="90%">
    <img class="item_image" v-if="index==2" src="@/assets/project/SafeFood.jpg" height="300" width="80%">
    <img class="item_image" v-if="index==3" src="@/assets/project/ChatBot.jpg" height="300">
    <img class="item_image" v-if="index==4" src="@/assets/project/WebMobile.jpg" height="300" width="80%">
    <img class="item_image" v-if="index==5" src="@/assets/project/AI_Chatbot.jpg" height="300" width="95%">

    <div class="item_content">
      <br>
      <div class="item_info">{{ item.info }}</div>
      <div class="item_disc">{{ item.disc }}</div>
      <div class="item_text">{{ item.text }}</div>
    </div>

    <br>
    <div class="item_date">{{ item.date }}</div>
    <br>

    <button class="item_button fun-btn" v-if="(index == 0) || (index == 1) || (index == 5)" @click="showPage(item.link,index)">동영상보기</button>
    <button  :class="[ index != 3 ? 'buttonDisable' : 'item_button fun-btn']" v-else @click="showPage(item.link,index)">더보기</button>
  </div>
</div>
</template>

<script>
import Project from '@/models/Project.js'

export default {
  data() {
    return {
      project: Project,
    }
  },
  computed: {

  },
  methods: {
    showPage(url, idx) {
      if (idx == 0) {
        window.open('https://youtu.be/ubBWLg_unf4')
      } else if (idx == 1) {
        window.open('https://youtu.be/3QlQ6UJwFwA')
      } else if(idx == 5){
        window.open('https://youtu.be/GAPUxAYqWHA')
      }else {
        if (url) {
          window.open(url)
        }
      }

    }
  }
}
</script>

<style>

.project {
  width: 100%;
  height: 100%;
  text-align: center;
  border-radius: 0px 0px 5px 5px;
  overflow-y: auto;
  background-color: #eee;
}


</style>

<style scoped>

.fun-btn {
  /* change bg color to get different hues    */
  background-color: salmon;
  color: white;
  padding: 0.2em 1em;
  border: none;
  transition: all .3s ease;
  border-radius: 5px;
  letter-spacing: 2px;
  text-transform: uppercase;
  outline: none;
  align-self: center;
  cursor: pointer;
  font-weight: bold;
}

.fun-btn:hover {
  animation: random-bg .5s linear infinite, grow 1300ms ease infinite;
}

.start-fun {
  background-color: #fff !important;
  /* change color of button text when fun is started   */
  color: salmon !important;
}

.buttonDisable{
  display: none;
}
</style>
